export const DashboardActionTypes = {
  SET_DASHBOARD_MOUNTED: 'SET_DASHBOARD_MOUNTED',
  SET_DASHBOARD_UNMOUNTED: 'SET_DASHBOARD_UNMOUNTED',
};
